import React from 'react'

const OfferView = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    formData,
    setFormData,
    offer,
    brands
  } = props;
  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      {console.log("offer", offer)}
      <div className="w-full flex flex-col pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Title
        </label>
        <sapn className="font-normal text-xs">{offer.title}</sapn>
      </div>

      <div className="w-full flex flex-col mt-2 pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white font-semibold">
          Description
        </label>
        <p className="font-normal text-xs max-h-[800px] overflow-auto">{offer.description}</p>
      </div>

      <div className="flex flex-col mt-2 pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Image
        </label>
        <div className="md:pl-3">
          <img src={offer.image} alt="Preview" className="w-32 h-32 mt-2" />
        </div>
      </div>

      <div className="w-full flex flex-col mt-2 pl-5">
        <span className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Brand
        </span>
        <span className="font-normal text-xs">
        {brands.find((brand) => brand.id === offer.brand_id)?.name || "N/A"}
        </span>
      </div>
    </div>
  );
};


export default OfferView